import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import clsx from "clsx"

const DraftPublishedBox = ({
  published = 0,
  has_been_published = 0,
  archived = 0,
  publish_date,
}) => {
  const [chipData, setChipData] = useState({})

  useEffect(() => {
    if (published === 1) {
      setChipData({ label: "PUBLISHED", id: "published" })
    } else if (publish_date && published === 0 && has_been_published === 0) {
      setChipData({ label: "SCHEDULED", id: "scheduled" })
    } else if (published === 0 && has_been_published === 1 && archived === 0) {
      setChipData({ label: "UNPUBLISHED", id: "unpublished" })
    } else if (published === 0 && archived === 0 && has_been_published === 0) {
      setChipData({ label: "DRAFT", id: "draft" })
    } else if (published === 0 && archived === 1) {
      setChipData({ label: "ARCHIVED", id: "archived" })
    }
  }, [published, has_been_published, archived, publish_date])

  return (
    <div
      className={clsx(
        "rounded-md text-xs font-semibold border w-[100px] p-1 flex justify-center items-center",
        chipData.id === "published" && "text-[#29B117] bg-[#D3EFCF]",
        chipData.id === "scheduled" && "text-[#8952D8] bg-[#E7D6FF]",
        chipData.id === "unpublished" && "text-[#FF8439] bg-[#FFDBC5]",
        chipData.id === "draft" && "text-[#FFD034] bg-[#FFF2C5]",
        chipData.id === "archived" && "text-[#808080] bg-[#DDDDDD]",
      )}
    >
      {chipData.label}
    </div>
  )
}

DraftPublishedBox.propTypes = {
  published: PropTypes.number,
  has_been_published: PropTypes.number,
  archived: PropTypes.number,
  publish_date: PropTypes.string,
}

export default DraftPublishedBox
